import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CryptoService } from '../services/crypto.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const cryptoService = inject(CryptoService);

  if (!isPlatformBrowser(platformId)) return next(req);

  const encryptedToken = localStorage.getItem('accessToken');
  if (!encryptedToken) return next(req);

  try {
    const token = cryptoService.doubleDecrypt(encryptedToken) as string;
    return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
  } catch {
    return next(req);
  }
};
